import { Badge, type BadgeType } from '@octopus-do/octopus-storybook'
import cx from 'classnames'
import type React from 'react'

import css from './Selectors.module.scss'

interface SelectorItem {
  id: string
  label: string
  icon: React.ReactNode
  // One badge in the card's corner (plan or beta); null for a plain card.
  badge: BadgeType | null
}

type Props = {
  items: SelectorItem[]
  activeItemId: string
  onChange: (selector: string) => void
}

const Selectors: React.FC<Props> = ({ items, activeItemId, onChange }) => (
  <div className={css.selectors}>
    {items.map((item) => (
      <div
        key={item.id}
        className={cx(css.selector, {
          [css.active]: activeItemId === item.id,
        })}
        onClick={() => onChange(item.id)}
      >
        {item.badge && (
          <div className={css.badge}>
            <Badge type={item.badge} />
          </div>
        )}
        {item.icon}
        <div className={css.text}>{item.label}</div>
      </div>
    ))}
  </div>
)

export default Selectors
